/* eslint-disable react-hooks/rules-of-hooks */
import useGetToken from "@/hooks/useGetToken";
import { NavItem } from "@/types/interface";
import {
  DockIcon,
  File,
  HandHelping,
  Image,
  LayoutDashboard,
  Map,
  MapPinned,
  Monitor,
  Package,
  Table2,
  UsersRound,
  View,
} from "lucide-react";

export const BASE_URL = process.env.NEXT_PUBLIC_API_URL;
export const REGION_URL = process.env.NEXT_PUBLIC_API_REGION;

type navDateType = {
  navItems: NavItem[];
};

export const getNavData = (): navDateType => {
  return {
    navItems: [
      {
        title: "Dashboard",
        url: "/dashboard",
        icon: LayoutDashboard,
      },
      {
        title: "Form Input",
        url: "/form-input",
        icon: DockIcon,
        items: [
          {
            title: "Semua Input",
            url: "/form-input/all",
          },
          {
            title: "Surat",
            url: "/form-input/letter",
          },
        ],
      },
      {
        title: "Tables",
        url: "/tables",
        icon: Table2,
        items: [
          {
            title: "tables admin",
            url: "/tables/admin",
          },
        ],
      },
      {
        title: "Maps View",
        url: "/maps",
        icon: Map,
      },
      {
        title: "Images",
        url: "/images",
        icon: Image,
      },
      {
        title: "View Label",
        url: "/view-label",
        icon: View,
      },
    ],
  };
};

// ADMIN F
export const getNavDataAdmin = (): navDateType => {
  const { decode } = useGetToken();
  const role = decode?.roleType;

  return {
    navItems: [
      {
        title: "Dashboard",
        url: "/dashboard",
        icon: LayoutDashboard,
      },
      {
        title: "GIS",
        url: "/gis",
        icon: MapPinned,
      },

      // --- Kondisi roleType P3B
      ...(role === "P3B"
        ? [
            {
              title: "Data Pengajuan",
              url: "/submission/all",
              icon: HandHelping,
            },
          ]
        : [
            {
              title: "Pengajuan",
              url: "/submission",
              icon: HandHelping,
              items: [
                {
                  title: "Data Pengajuan",
                  url: "/submission/all",
                },
                {
                  title: "Pengajuan Ditolak",
                  url: "/submission/rejected",
                },
              ],
            },
          ]),

      {
        title: "Monitoring",
        url: "/monitoring",
        icon: Monitor,
      },
      {
        title: "Manajemen Pengguna",
        url: "/management-users",
        icon: UsersRound,
      },
      {
        title: "Stok",
        url: "/stock",
        icon: Package,
      },
      {
        title: "Laporan",
        url: "/report",
        icon: File,
      },
    ],
  };
};
